import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('hj4u_user') || 'null'); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('hj4u_token'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token && !user) {
      api.get('/auth/me').then(r => {
        setUser(r.data);
        localStorage.setItem('hj4u_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('hj4u_token');
        localStorage.removeItem('hj4u_user');
        setToken(null);
      });
    }
  }, [token, user]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post('/auth/login', { email, password });
      localStorage.setItem('hj4u_token', r.data.token);
      localStorage.setItem('hj4u_user', JSON.stringify(r.data.user));
      setToken(r.data.token);
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('hj4u_token');
    localStorage.removeItem('hj4u_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
